"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataSlice = /*#__PURE__*/function () {
  function DataSlice(arrayBuffer, sliceOffset, littleEndian, bigTiff) {
    (0, _classCallCheck2.default)(this, DataSlice);
    this._dataView = new DataView(arrayBuffer);
    this._sliceOffset = sliceOffset;
    this._littleEndian = littleEndian;
    this._bigTiff = bigTiff;
  }

  (0, _createClass2.default)(DataSlice, [{
    key: "sliceOffset",
    get: function get() {
      return this._sliceOffset;
    }
  }, {
    key: "sliceTop",
    get: function get() {
      return this._sliceOffset + this.buffer.byteLength;
    }
  }, {
    key: "littleEndian",
    get: function get() {
      return this._littleEndian;
    }
  }, {
    key: "bigTiff",
    get: function get() {
      return this._bigTiff;
    }
  }, {
    key: "buffer",
    get: function get() {
      return this._dataView.buffer;
    }
  }, {
    key: "covers",
    value: function covers(offset, length) {
      return this.sliceOffset <= offset && this.sliceTop >= offset + length;
    }
  }, {
    key: "readUint8",
    value: function readUint8(offset) {
      return this._dataView.getUint8(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readInt8",
    value: function readInt8(offset) {
      return this._dataView.getInt8(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readUint16",
    value: function readUint16(offset) {
      return this._dataView.getUint16(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readInt16",
    value: function readInt16(offset) {
      return this._dataView.getInt16(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readUint32",
    value: function readUint32(offset) {
      return this._dataView.getUint32(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readInt32",
    value: function readInt32(offset) {
      return this._dataView.getInt32(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readFloat32",
    value: function readFloat32(offset) {
      return this._dataView.getFloat32(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readFloat64",
    value: function readFloat64(offset) {
      return this._dataView.getFloat64(offset - this._sliceOffset, this._littleEndian);
    }
  }, {
    key: "readUint64",
    value: function readUint64(offset) {
      var left = this.readUint32(offset);
      var right = this.readUint32(offset + 4);
      var combined;

      if (this._littleEndian) {
        combined = left + Math.pow(2, 32) * right;

        if (!Number.isSafeInteger(combined)) {
          throw new Error("".concat(combined, " exceeds MAX_SAFE_INTEGER. ") + 'Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues');
        }

        return combined;
      }

      combined = Math.pow(2, 32) * left + right;

      if (!Number.isSafeInteger(combined)) {
        throw new Error("".concat(combined, " exceeds MAX_SAFE_INTEGER. ") + 'Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues');
      }

      return combined;
    } // adapted from https://stackoverflow.com/a/55338384/8060591

  }, {
    key: "readInt64",
    value: function readInt64(offset) {
      var value = 0;
      var isNegative = (this._dataView.getUint8(offset + (this._littleEndian ? 7 : 0)) & 0x80) > 0;
      var carrying = true;

      for (var i = 0; i < 8; i++) {
        var byte = this._dataView.getUint8(offset + (this._littleEndian ? i : 7 - i));

        if (isNegative) {
          if (carrying) {
            if (byte !== 0x00) {
              byte = ~(byte - 1) & 0xff;
              carrying = false;
            }
          } else {
            byte = ~byte & 0xff;
          }
        }

        value += byte * Math.pow(256, i);
      }

      if (isNegative) {
        value = -value;
      }

      return value;
    }
  }, {
    key: "readOffset",
    value: function readOffset(offset) {
      if (this._bigTiff) {
        return this.readUint64(offset);
      }

      return this.readUint32(offset);
    }
  }]);
  return DataSlice;
}();

exports.default = DataSlice;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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